import { useMemo } from 'react';

export const useRemSize = () => useMemo(() => {
    const style = getComputedStyle(document.documentElement);

    return parseFloat(style.fontSize);
}, []);
